(function () {
  // NEYL — How-to tabs.
  // Click a tab → switch the visible <video> + body panel. Active video plays
  // muted on loop; others stay paused. Section uses an IntersectionObserver
  // so playback only starts once the visitor has scrolled to it (saves
  // bandwidth on a section that's far down the page).

  function initSection(root) {
    if (root.dataset.neylHowtoReady === '1') return;
    root.dataset.neylHowtoReady = '1';

    var tabs = Array.prototype.slice.call(root.querySelectorAll('[data-neyl-howto-tab]'));
    var panels = Array.prototype.slice.call(root.querySelectorAll('[data-neyl-howto-panel]'));
    var slots = Array.prototype.slice.call(root.querySelectorAll('[data-neyl-howto-video]'));
    var videos = Array.prototype.slice.call(root.querySelectorAll('[data-neyl-howto-video-el]'));
    if (!tabs.length) return;

    var activeIdx = 0;

    function setActive(idx) {
      activeIdx = idx;
      for (var i = 0; i < tabs.length; i++) {
        var on = i === idx;
        tabs[i].classList.toggle('is-active', on);
        tabs[i].setAttribute('aria-selected', on ? 'true' : 'false');
      }
      for (var j = 0; j < panels.length; j++) {
        panels[j].toggleAttribute('hidden', j !== idx);
      }
      for (var k = 0; k < slots.length; k++) {
        slots[k].toggleAttribute('hidden', k !== idx);
      }
      // Pause every video, then play the active one. Reset its position so
      // each switch shows the action from the start, which is what you want
      // for a how-to demo.
      for (var v = 0; v < videos.length; v++) {
        if (v === idx) {
          try { videos[v].currentTime = 0; } catch (e) {}
          videos[v].muted = true;
          var p = videos[v].play();
          if (p && typeof p.catch === 'function') p.catch(function () {});
        } else {
          videos[v].pause();
        }
      }
    }

    tabs.forEach(function (tab, i) {
      tab.addEventListener('click', function () { setActive(i); });
      tab.addEventListener('keydown', function (e) {
        // Left/right arrow navigation between tabs (a11y nicety)
        if (e.key === 'ArrowRight') {
          var next = (i + 1) % tabs.length;
          tabs[next].focus();
          setActive(next);
        } else if (e.key === 'ArrowLeft') {
          var prev = (i - 1 + tabs.length) % tabs.length;
          tabs[prev].focus();
          setActive(prev);
        }
      });
    });

    // Autoplay the active video only when the section enters the viewport.
    if ('IntersectionObserver' in window) {
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            var v = videos[activeIdx];
            if (v) {
              v.muted = true;
              var p = v.play();
              if (p && typeof p.catch === 'function') p.catch(function () {});
            }
          } else {
            // Pause everything when scrolled away
            for (var i = 0; i < videos.length; i++) videos[i].pause();
          }
        });
      }, { root: null, threshold: 0.3 });
      io.observe(root);
    } else {
      // No IO support — just play the first video on init
      var v0 = videos[0];
      if (v0) {
        v0.muted = true;
        var p = v0.play();
        if (p && typeof p.catch === 'function') p.catch(function () {});
      }
    }
  }

  function initAll(scope) {
    var nodes = (scope || document).querySelectorAll('[data-neyl-howto]');
    for (var i = 0; i < nodes.length; i++) initSection(nodes[i]);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { initAll(); });
  } else {
    initAll();
  }
  document.addEventListener('shopify:section:load', function (e) { initAll(e.target); });
})();
